import React, { PropTypes } from 'react';
import B from 'bem-cn';

import './index.scss';
import Tabs, { Tab } from '../tabs';

import { scrollToElement } from '../../utils/scroll';
import getStaticContent from '../../utils/getStaticContent';

const cl = B('Examples');

export default class Examples extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIdx: 0
    };

    this.staticContent = getStaticContent('examples', props.currentPageName);
  }

  static propTypes = {
    passRef: React.PropTypes.func,
    currentPageName: PropTypes.string.isRequired
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    }
    return false;
  }

  onTabChange() {
    scrollToElement('#examples');
  }

  render() {
    return (
      <div className={cl} id="examples" ref={this.props.passRef}>
        <div className="container">
          <div className={cl('title')}>{this.staticContent.title}</div>
          <Tabs index={this.state.tabIdx} onChange={this.onTabChange}>
            {this.staticContent.tabs.map((item, itemIndex) => (
              <Tab label={item.title} key={itemIndex}>
                <div dangerouslySetInnerHTML={{ __html: item.content }} />
              </Tab>
            ))}
          </Tabs>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/examples/index.jsx